import { FGDivider } from '@fg/design-system';
import React from 'react';

export const InsightAndEventSeparator = React.memo(() => {
    return (
        <div
            style={{
                marginBlock: 40,
            }}>
            <FGDivider />
        </div>
    );
});
